var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGoogleplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 48.791,
    viewBox: "0 0 40 48.791",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6,30.488l4.93,5.987-19.6,11.856Zm6.926-8.452,8.687,5.282a1.546,1.546,0,0,1,0,2.7L38.521,35.3l-5.4-6.574ZM16.8,9.006l19.6,11.856-4.93,5.987Zm-7.513-4.7,1.526.939L30.069,28.61,10.817,52.088l-1.291.822A1.038,1.038,0,0,1,8,51.97V5.015A.906.906,0,0,1,9.291,4.311Z",
    transform: "translate(-8 -4.237)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogleplay);
export default __webpack_public_path__ + "static/media/icon-googleplay.13f6929b.svg";
export { ForwardRef as ReactComponent };